import {
  FETCH_CATALOG_SUCCEEDED,
  FETCH_CATALOG_FAILED,
} from 'store/actions/catalogs/types';

export const initialState = {};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CATALOG_SUCCEEDED:
      return {
        ...state,
        [action.payload.identifier]: action.payload.catalog,
      };
    case FETCH_CATALOG_FAILED:
      return {
        ...state,
        [action.payload.identifier]:
          state[action.payload.identifier] || action.payload.catalog,
      };
    default:
      return state;
  }
};
